import { createAction } from "redux-actions";

export const updateUser = createAction("updateUserSignIn");
